import styled from 'styled-components';

const Box = ({ children }) => {
  return <StyledBox>{children}</StyledBox>;
};

export default Box;

const StyledBox = styled.div`
  border: 1px solid lightgray;
  border-radius: 10px;
`;
